import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface Order {
    orderNumber: string;
    orderDate: string;
    firstName: string;
    lastName: string;
    status: string;
    orderTotal: string;
    customerNumber: string;
    returnNumber?: string;
}

export const orderSearchApi = createApi({
    reducerPath: 'orderSearchApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/order-search',
        prepareHeaders: headers => {
            headers.set(
                'litium-request-context',
                JSON.stringify(window.__litium.requestContext)
            );
            headers.set('Content-Type', 'application/json');
            return headers;
        },
        credentials: 'include',
    }),
    endpoints: builder => ({
        orderSearch: builder.mutation<Order[], {query: string, searchReturnOrders: boolean}>({
            query: (params) => {
                const { query, searchReturnOrders } = params;
                return {
                    url: `?query=${encodeURIComponent(query)}&searchReturnOrders=${searchReturnOrders}`,
                    method: 'GET',
                    headers: {
                        RequestVerificationToken: window.localStorage.getItem(
                            'requestVerificationToken'
                        ) || '',
                    },
                };
            },
        }),
    }),
});

export const { useOrderSearchMutation } = orderSearchApi;
